import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4461a42e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "section-input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-over" }, "보이는 ARS가 종료되었습니다.", -1))
const _hoisted_4 = { class: "bottom-btn-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_logo = _resolveComponent("header-logo")!
  const _component_board_marquee = _resolveComponent("board-marquee")!
  const _component_complete_text_calltype = _resolveComponent("complete-text-calltype")!
  const _component_complete_img_calltype = _resolveComponent("complete-img-calltype")!
  const _component_complete_text_wait = _resolveComponent("complete-text-wait")!
  const _component_button_big = _resolveComponent("button-big")!
  const _component_button_icon = _resolveComponent("button-icon")!
  const _component_complete_dialog_fail_connect = _resolveComponent("complete-dialog-fail-connect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_logo),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_board_marquee),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_complete_text_calltype),
        _createVNode(_component_complete_img_calltype),
        _createVNode(_component_complete_text_wait)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, [
          _createVNode(_component_button_big, {
            command: "showMore",
            title: "오토콜이 궁금해요",
            subTitle: "오토콜에 대해 더 알고 싶다면?"
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_button_icon, {
            command: "failConnect",
            icon: "icon-calloff.png",
            text: "상대방과 연결이 되지 않았나요?",
            class: "btn-icon-underline"
          })
        ])
      ])
    ]),
    (_ctx.isDialogOpen)
      ? (_openBlock(), _createBlock(_component_complete_dialog_fail_connect, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}